import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import routes from './routes';
import ReactGA from 'react-ga';
import { ViewportProvider } from './utils';
import { Widget } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';

ReactGA.initialize('UA-160730013-2')

function RouteChangeListener() {
  const location = useLocation();
  const { pathname } = location;

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])

  ReactGA.pageview(pathname)

  return null;
}

function App() {
  const handleNewUserMessage = (newMessage) => {
    console.log(`New message incoming! ${newMessage}`);
    // Now send the message throught the backend API
  };

  return (
    <ViewportProvider>
      <Widget
        handleNewUserMessage={handleNewUserMessage}
        showCloseButton
        subtitle=""
      />
      <Router>
        <RouteChangeListener />

        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          {
            routes.map((route, index) => (
              <Route
                path={route.path} key={index}
                render={props => (
                  <route.component {...props} {...route}/>
                )}
              />
            ))
          }
        </Switch>
      </Router>
    </ViewportProvider>
  );
}

export default App;
